<template>
  <MainLayout>
    <main class="new-estimate">
      <AntForm :form="form" @submit.prevent="handleSubmit">
        <!-- Hidden submit input to prevent submits on random buttons click -->
        <input type="submit" hidden />
        <Stepper :steps="steps" v-on:stepChanged="handleStepChanged">
          <template v-slot:footer v-if="showSaveButton">
            <PrimaryButton
              @click="saveEstimate"
              class="new-estimate__save-button"
              :loading="savingEstimate"
            >
              {{ $t('estimate.buttons.save') }}
            </PrimaryButton>
          </template>
        </Stepper>
      </AntForm>
    </main>
  </MainLayout>
</template>

<script>
import estimateViewMixin from '@/common/mixins/estimate-view';
import api from '@/api';

export default {
  name: 'NewEstimateView',
  mixins: [estimateViewMixin],
  methods: {
    async saveEstimate() {
      try {
        this.savingEstimate = true;
        await api.estimate.save(this.getSanitizedEstimateValues());
        this.$notifications.success(this.$t('estimate.estimateSavedMessage'));
        this.$router.push('/dashboard');
      } catch (error) {
        this.$notifications.error(error.message);
      } finally {
        this.savingEstimate = false;
      }
    },
  },
};
</script>

<style lang="scss">

</style>
